export default "__VITE_ASSET__BKFwTPBW__"